export default "__VITE_ASSET__8308b9b1__"